var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPagePrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-s-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.20433 9.99924L12.9168 13.7117L11.8563 14.7722L7.08333 9.99924L11.8563 5.22624L12.9168 6.28674L9.20433 9.99924Z",
    fill: "#525866"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagePrev);
export default __webpack_public_path__ + "static/media/icon-page-prev.124256773921efca6d3e19d9e9c108aa.svg";
export { ForwardRef as ReactComponent };